import React from 'react';

import Icon from '../Icons';
import { LinkButton } from '../../styles/global';
import { useGlobal } from '../../contexts/Global/context';

import * as S from './styles';

const Pagination = ({ loading, alreadySearched, pagination, pages, handleChangePage, type }) => {
    const { contrastTheme } = useGlobal();

    return (
        <div>
            {!loading && alreadySearched && pagination.showingData.length > 0 && type === 'simple' && (
                <S.SimplePagination>
                    {pagination.activePage > 0 && (
                        <LinkButton id="back" onClick={() => handleChangePage(pagination.activePage - 1)}>
                            <S.IconBorder isLeft>
                                <Icon name="ArrowLeft" color={contrastTheme ? '#000000' : '#FFFFFF'} />
                            </S.IconBorder>
                        </LinkButton>
                    )}

                    {pages.length > 1 && pagination.activePage !== pages[pages.length - 1] && (
                        <LinkButton id="foward" onClick={() => handleChangePage(pagination.activePage + 1)}>
                            <S.IconBorder>
                                <Icon name="ArrowRight" color={contrastTheme ? '#000000' : '#FFFFFF'} />
                            </S.IconBorder>
                        </LinkButton>
                    )}
                </S.SimplePagination>
            )}

            {!loading && alreadySearched && pagination.showingData.length > 0 && type !== 'simple' && (
                <S.Pagination>
                    {pagination.activePage > 0 && (
                        <LinkButton id="back" onClick={() => handleChangePage(pagination.activePage - 1)}>
                            <Icon name="ArrowLeft" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                            <S.PaginationText>Anterior</S.PaginationText>
                        </LinkButton>
                    )}
                    {pages.map((page) => (
                        <div
                            key={`page-${page}`}
                            onClick={() => handleChangePage(page)}
                            className={`page ${page === pagination.activePage ? 'active' : ''}`}
                        >
                            {page + 1}
                        </div>
                    ))}
                    {pages.length > 1 && pagination.activePage !== pages[pages.length - 1] && (
                        <LinkButton id="foward" onClick={() => handleChangePage(pagination.activePage + 1)}>
                            <S.PaginationText>Próxima</S.PaginationText>
                            <Icon name="ArrowRight" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                        </LinkButton>
                    )}
                </S.Pagination>
            )}
        </div>
    );
};

export default Pagination;
